import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "semantic-ui-react";
import {
  updateCancelAppointmentModalVisibility,
  updateSendCancellationEmailToggle
} from "../../../actions/menu";
import { updateBooking, sendBookingEmail } from "../../../actions/booking";
import { Checkbox } from "semantic-ui-react";
import { toApiDateTime } from "../../../utils/helpers";
@connect(mapStateToProps)
export default class CancelAppointmentModal extends Component {
  closeApp = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "close"
      }
    });
    window.dispatchEvent(event);
  };

  updateCancelAppointmentVisibility = isVisible => {
    this.props.dispatch(updateCancelAppointmentModalVisibility(isVisible));
  };

  getCancelAppointmentModal = () => {
    let {
      currentBookingId,
      advancedAppointmentStepData,
      appointmentStepData,
      gotValidOffer,
      advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
    } = this.props;
    let { recurringToggleOn } = this.props.advancedAppointmentStepData;
    let {
      cancelAppointmentVisible,
      savingBooking,
      sendCancellationEmailToggled
    } = this.props;
    let {
      ThisOnly,
      ThisAndFuture,
      CancelRecurringAppText
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;
    let {
      No,
      Yes,
      CancellationEmailToggleTitle
    } = window.APP.LANGUAGE.Shared.PopupWindows;
    let { selectedCustomer } = appointmentStepData;
    if (!cancelAppointmentVisible) {
      return "";
    }

    let handleCancelAppointment = applyto => {
      let {
        selectedDate,
        selectedTime
      } = appointmentStepData.multiServiceList[0];

      let payload = { status: 5 };
      if (applyto && applyto === "thisonly") {
        payload = { status: 5, applyto: "thisonly" };
        advancedAppointmentStepData.recurringToggleOn = false; // disable recurring to avoid creating a second-timeline
      } else if (applyto && applyto === "thisandfuture") {
        payload = { status: 5, applyto: "thisandfuture" };
      }

      let cb = () => {
        this.closeApp();
      };
      if (sendCancellationEmailToggled) {
        let starttime = toApiDateTime(
          selectedDate,
          selectedTime.stringValue,
          appointmentStepData.timeList
        );
        this.props.dispatch(
          sendBookingEmail(currentBookingId, 5, payload.applyto, starttime, cb)
        );
      } else if (currentBookingId) {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            payload.status,
            payload.applyto,
            cb,
            gotValidOffer,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      }
    };

    let saveButtonClasses = "ui button  savebtn";
    let discardButtonClasses = "ui button cancel-btn";
    let thisOnlyButtonClasses = "ui button recur-btn";
    let thisandfutureButtonClasses = "ui button recur-btn2";

    let recurringButtons = () => {
      return (
        <div>
          <div
            className={thisOnlyButtonClasses}
            onClick={() => handleCancelAppointment("thisonly")}
          >
            {ThisOnly}
          </div>
          <div
            className={thisandfutureButtonClasses}
            onClick={() => handleCancelAppointment("thisandfuture")}
          >
            {ThisAndFuture}
          </div>
        </div>
      );
    };

    if (savingBooking) {
      saveButtonClasses += " loading disabled";
      discardButtonClasses += " disabled";
      thisOnlyButtonClasses += " disabled";
      thisandfutureButtonClasses += " disabled";
    }

    let normalCancelButtons = () => {
      return (
        <div>
          <div
            className={discardButtonClasses}
            onClick={() => this.updateCancelAppointmentVisibility(false)}
          >
            {No}
          </div>
          <div
            className={saveButtonClasses}
            onClick={() => handleCancelAppointment("thisonly")}
          >
            {Yes}
          </div>
        </div>
      );
    };

    let handleCancellationEmailToggle = () => {
      this.props.dispatch(
        updateSendCancellationEmailToggle(!sendCancellationEmailToggled)
      );
    };

    return (
      <Modal
        className="bookingdetails-model cancel-appointment-modal transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          <div className={`save-box ${recurringToggleOn ? "recurrences" : ""}`}>
            <section className="header">
              {window.APP.LANGUAGE.Pages.Appointment.ConfirmCancel}
              {recurringToggleOn ? (
                <p className="save_text">{CancelRecurringAppText}</p>
              ) : (
                ""
              )}
              <div
                className="close_button"
                onClick={() => this.updateCancelAppointmentVisibility(false)}
              ></div>
              {selectedCustomer && selectedCustomer.id ? (
                <div className="notification-toggle">
                  <Checkbox
                    className="no-bold mrtxs"
                    label={CancellationEmailToggleTitle}
                    onChange={handleCancellationEmailToggle}
                    checked={sendCancellationEmailToggled}
                  />
                </div>
              ) : (
                ""
              )}
            </section>

            <section className="save_box_buttons">
              {recurringToggleOn ? recurringButtons() : normalCancelButtons()}
            </section>
          </div>
        </Modal.Content>
      </Modal>
    );
  };

  render() {
    return this.getCancelAppointmentModal();
  }
}

function mapStateToProps(state) {
  return {
    message: state.globalErrorReducer.message,
    cancelAppointmentVisible: state.menuReducer.cancelAppointmentVisible,
    savingBooking: state.bookingReducer.savingBooking,
    advancedAppointmentStepDataBeforeUserHasMadeAnyChanges:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
    sendCancellationEmailToggled:
      state.menuReducer.sendCancellationEmailToggled,
    currentBookingId: state.bookingReducer.currentBookingId,
    gotValidOffer: state.bookingReducer.gotValidOffer,
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData
  };
}
